import { useUser } from "@clerk/clerk-react";
import { useAnalytics } from "../AnalyticsProvider";
import { useEffect } from "react";
import { useSessionStorage } from "usehooks-ts";

export function UserIdentifier() {
  const { trackEvent, identify } = useAnalytics();
  const { user } = useUser();
  const [hasLoggedInThisSession, setHasLoggedInThisSession] = useSessionStorage(
    "hasLoggedInThisSession",
    false
  );

  const [, setHadSession] = useSessionStorage("hadSession", false);

  useEffect(() => {
    if (user && !hasLoggedInThisSession) {
      sessionStorage.removeItem("currentBotSession");
      sessionStorage.removeItem("hasLoggedInThisSession");
      const userId = user.id;
      const userProperties = {
        email: user.primaryEmailAddress?.emailAddress,
        name: user.fullName,
      };

      identify(userId, userProperties);

      const signUpTracked = user.unsafeMetadata?.signUpTracked;

      if (!signUpTracked) {
        trackEvent("signed_up", {
          ...userProperties,
          signed_up_at: user.createdAt,
        });

        user.update({
          unsafeMetadata: {
            ...user.unsafeMetadata,
            signUpTracked: true,
          },
        });
      }

      trackEvent("logged_in", userProperties);

      setHasLoggedInThisSession(true);
      setHadSession(true);
    }
  }, [user]);

  return null;
}
